import { api } from 'api';
import { State, Store } from 'store/types';
import { GlobalEvents } from '../global';
import { FETCH_RELATED_SERVICES } from './related-services-constants';
import { RelatedService } from './related-services-types';

/**
 * Загрузка информации о доступных сервисах
 * @param store
 * @param {string} categoryId
 * @param {string} regionId
 * @returns {Promise<RelatedService[]>}
 */
export const getRelatedServices = (store: Store, categoryId: string, regionId: string) => {
  const { apiKey, orchestratorHost, useCredentials, requestID } = store.get();

  return api.get<RelatedService[]>(
    'get-related-services',
    { categoryId, regionId },
    {
      orchestratorHost,
      useCredentials,
      apiKey,
      requestID,
    }
  );
};

/**
 * Экшен загрузки информации о доступных сервисах
 * @param {Store} store
 * @param {string} categoryId
 * @returns {Promise<State>}
 */
export const loadRelatedServicesAction = (store: Store, categoryId: string) =>
  new Promise<State>(resolve => {
    const { modelJson } = store.get();
    if (!modelJson.model) {
      resolve(store.get());
      return;
    }

    store.dispatch(GlobalEvents.setRequestParams, {
      orchestratorHost: process.env.ORCHESTRATOR_HOST,
      useCredentials: process.env.USE_CREDENTIALS === '1',
      apiKey: process.env.API_KEY,
    });
    store.dispatch(FETCH_RELATED_SERVICES.init, categoryId);

    const unsub = store.on('@dispatch', state => {
      if (state.relatedServices.loading) {
        return;
      }

      unsub();
      resolve(store.get());
    });
  });
